import axios from 'axios';

const apiClient = axios.create({
  // baseURL: 'https://localhost:5208/api/',
  baseURL: 'https://api.mysfs24.com/api/', 
});

export default apiClient;